import { CONTRACT_TYPES } from '@vy/types';
import { useVyForm } from '../../../../hooks/use-vy-form';
import {
  AssignCustomerFormFullRequiredSchema,
  AssignCustomerFormSchema,
} from '../types/assign-customer-dialog-form-types/assign-customer-form-schema';

export function useCreateContractForm(initialCustomerId?: string, isStartDateRequired = false) {
  const schema = isStartDateRequired ? AssignCustomerFormFullRequiredSchema : AssignCustomerFormSchema;

  return useVyForm<typeof schema>({
    schema,
    defaultValues: {
      customerId: initialCustomerId,
      startDate: undefined,
      contractType: CONTRACT_TYPES.Standard,
    },
  });
}
